import { getToken } from '@/lib/auth'

// Multipart upload of an EPUB to the REST endpoint (GraphQL stays JSON-only).
export async function uploadBook(file: File, targetLanguage: string): Promise<{ slug: string }> {
  const form = new FormData()
  form.append('epub', file)
  form.append('target_language', targetLanguage)

  const res = await fetch('/api/books', {
    method: 'POST',
    headers: { Authorization: `Bearer ${getToken() ?? ''}` },
    body: form,
  })

  if (!res.ok) {
    const body = await res.json().catch(() => ({}))
    throw new Error(body.errors?.join(', ') || body.error || 'Upload failed')
  }
  return res.json()
}

// Authenticated EPUB download (the endpoint needs the Bearer token, so we can't
// use a plain <a href>). Fetches the blob and triggers a save.
export async function downloadExport(slug: string, format: 'translated' | 'original') {
  const res = await fetch(`/api/books/${slug}/export?format=${format}`, {
    headers: { Authorization: `Bearer ${getToken() ?? ''}` },
  })
  if (!res.ok) throw new Error('Export failed')

  const blob = await res.blob()
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = `${slug}-${format}.epub`
  document.body.appendChild(a)
  a.click()
  a.remove()
  URL.revokeObjectURL(url)
}
